export const validateProjects = data => {
  if (data && data.allProjectsPaginated && data.allProjectsPaginated.projects) {
    return data.allProjectsPaginated.projects
  }
  return []
}



// WEBPACK FOOTER //
// ./src/helpers/allProjectsPaginatedDataHelper.ts